import { useMatchMedia } from '@nike/nike-design-system-components';
import tokens from '@nike/design-system-base';

// the "- 1" is so that the smallerThan ranges won't overlap with the mediaQueries min-width ranges
export var getMaxWidth = function getMaxWidth(device) {
  return tokens.bp(device) - 1;
};
var useSmallerThan = function useSmallerThan(device) {
  var matches = useMatchMedia("(max-width: ".concat(getMaxWidth(device), "px)"));
  return matches;
};

// returns true for anything smaller than desktop
export var useIsMobile = function useIsMobile() {
  var isMobile = useSmallerThan('desktop');
  return isMobile;
};
export var useIsDesktop = function useIsDesktop() {
  return !useIsMobile();
};